import React from 'react';
import { useTranslation } from 'react-i18next';
import { UptimeFooter } from '@uptime/uptime-component';
import { scrollToTop } from 'utils/function';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import usePrivacyFooter from 'hooks/usePrivacyFooter';
import { VersionContext, versionHandler } from 'hooks/version';

const Footer = () => {
  const { generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );
  const [gitInfo, setGitInfo] = React.useState({
    version: '',
    hash: '',
  });
  const { version: releaseNumber, uptimeVersionName } = generalConfig || {};
  const { t } = useTranslation('footer');
  const copyright = `© ${t('footer:copyright')} `;
  const versionName = uptimeVersionName || '';
  const version = `| ${t('footer:version')} ${versionName}`;
  const release = ` | ${t('footer:versionLabel')}${releaseNumber} (${gitInfo.version}-${gitInfo.hash})`;
  const { dataPrivacy } = usePrivacyFooter();

  React.useEffect(() => {
    if (!generalConfig?.version) return;
    (async () => {
      const context: VersionContext = {
        res: {},
      };
      await versionHandler(context, {});
      const { version, hash } = context?.res;
      setGitInfo({ version, hash });
    })();
  }, [generalConfig]);

  return (
    <UptimeFooter
      copyright={copyright}
      version={versionName ? version : ''}
      release={releaseNumber ? release : ''}
      privacyData={dataPrivacy}
      backToTopLabel={t(`footer:backToTop`)}
      scrollToTop={scrollToTop}
    />
  );
};

export default Footer;